import { Image } from "expo-image";
import * as React from "react";

export function KPITeamEmptyIllustration() {
  return (
    <Image
      source={require("./goals.svg")}
      style={{ flex: 1 }}
      contentFit="contain"
    />
  );
}
